'use client';

import { useEffect } from 'react';

export function SmoothScrollHandler() {
  useEffect(() => {
    // Handle hash scrolling on navigation
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        // Small delay to ensure the page is fully rendered
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 100);
      }
    };
    handleHashScroll();
  }, []);

  return (
    <style jsx global>{`
      html {
        scroll-behavior: smooth;
      }
    `}</style>
  );
}
